import { EditMenu } from 'app/modules/wallforming/components/menu-container/EditMenu';
import { ProjectsMenu } from 'app/modules/wallforming/components/menu-container/ProjectsMenu';
import { ViewMenu } from 'app/modules/wallforming/components/menu-container/ViewMenu';
import { useIsStandaloneMode } from 'shared/hooks/useIsStandaloneMode';

export const MenuBar = () => {
    const isStandaloneMode = useIsStandaloneMode();

    return (
        <div className="flex items-center h-7 bg-background-gray-light border-b border-border-default select-none pointer-events-auto z-10">
            <ViewMenu />
            <EditMenu />
            {isStandaloneMode && <ProjectsMenu />}
        </div>
    );
};
